import { render, staticRenderFns } from "./KanabakariSetting.vue?vue&type=template&id=5c99b677&scoped=true&"
import script from "./KanabakariSetting.vue?vue&type=script&lang=js&"
export * from "./KanabakariSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c99b677",
  null
  
)

export default component.exports